// File: SmartCardBusinessPreview.jsx

import React from 'react';
import SmartCardBusiness from './../components/smartcard/Templates/SmartCardBusiness';

export default function SmartCardBusinessPreview() {
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center p-10">
      <SmartCardBusiness
        businessName="Million2Trillion Inc."
        industry="Fintech"
        subCategory="Investor Marketplace"
        cardNumber="9876 1234 5678 0001"
        tier="Gold"
        mode="Business"
        isVerified={true}
        isTrusted={true}
        reviewCount={18}
        qrCodeUrl="https://million2trillion.com/r/M2T9876"
        logoUrl="/user-photos/m2t-logo.png"
       // joinedOn="2025-05-01"
        cardValidity="12/26"
        businessCode="M2T-BZ987"
       // email="admin@million2trillion.com"
        country="India"
        website="www.million2trillion.com"
        showLogo={true} // ✅ Show M2T logo in preview
        status="Verified"
        badge="Trusted"
      />
    </div>
  );
}
